module.exports = __webpack_public_path__ + "static/tutorial_month_example-571d5a91115443fa8ed1b60a33ff37bd.png";